import './InlineEditor.scss';

import InlineEditor from './InlineEditor';

export default InlineEditor;
